export default function (name: string) {
  return name
    .trim()
    .split(/\s+/)
    .flatMap((_name) => {
      return _name
        .split("-")
        .map((__name) => {
          return __name.charAt(0);
        });
    })
    .join("")
    .toUpperCase();
}
